function cleanText(value) {
  const text = String(value || "").trim();
  return text || "";
}

function pickFirst(...values) {
  for (const value of values) {
    const text = cleanText(value);
    if (text) return text;
  }
  return "";
}

function includesPart(base, part) {
  return cleanText(base).toLowerCase().includes(cleanText(part).toLowerCase());
}

export function formatFacilityAddress({
  address = "",
  postalCode = "",
  city = "",
  country = "",
} = {}) {
  let line = cleanText(address);

  for (const part of [postalCode, city, country]) {
    const nextPart = cleanText(part);
    if (!nextPart || includesPart(line, nextPart)) continue;
    line = line ? `${line}, ${nextPart}` : nextPart;
  }

  return line;
}

export function resolveFacilityAddress({
  addressCandidates = [],
  postalCodeCandidates = [],
  cityCandidates = [],
  countryCandidates = [],
} = {}) {
  return formatFacilityAddress({
    address: pickFirst(...addressCandidates),
    postalCode: pickFirst(...postalCodeCandidates),
    city: pickFirst(...cityCandidates),
    country: pickFirst(...countryCandidates),
  });
}
